<template>
    <section 
        class="gz-data-row_small" 
    >
        <GZ-TableDataCol slot="cols" style="width: auto">
            <!-- Аватар -->
            <div class="gz-col-inner">
                <span class="icon-user-1 gz-staff__avatar"></span>
            </div>
        </GZ-TableDataCol>
        <GZ-TableDataCol slot="cols">
            <!-- ФИО -->
            <div class="gz-col-inner">
                <span title="Имя">
                    {{ data.attributes.lname }}
                    {{ data.attributes.fname }}
                    {{ data.attributes.pname || '' }}
                </span>
            </div>
        </GZ-TableDataCol>
        <GZ-TableDataCol slot="cols">
            <!-- Телефон -->
            <div class="gz-col-inner">
                <span class="icon-mobile-alt-solid"></span>
                <span>&nbsp;&nbsp;{{ data.attributes.phone }}</span>
            </div>
        </GZ-TableDataCol>
        <GZ-TableDataCol slot="cols">
            <!-- email -->
            <div class="gz-col-inner">
                <span class="icon-mail"></span>
                <span>&nbsp;&nbsp;{{ data.attributes.email }}</span>
            </div>
        </GZ-TableDataCol>
        <GZ-TableDataCol slot="cols">
            <!-- Описание -->
            <div class="gz-col-inner">
                <span>{{ data.attributes.about }}</span>
            </div>
        </GZ-TableDataCol>
        <GZ-TableDataCol slot="cols" style="width: auto">
            <!-- Checkups -->
            <div class="gz-col-inner gz-col-inner_actions">
                <button
                    @click="$router.push(data.attributes.uid + '/checkups')"
                    title="Проверки сотрудника"
                    class="gz-icon_cercle gz-icon_cercle_default gz-icon_cercle_accent">
                    <span class="icon-clipboard"></span>
                </button>
                <button
                    v-if="isAdmin()"
                    @click="$router.push(data.attributes.uid + '/info')"
                    class="gz-icon_cercle gz-icon_cercle_default">
                    <span class="icon-pencil"></span>
                </button>
            </div>
        </GZ-TableDataCol>
        <GZ-TableDataCol v-if="isAdmin()" slot="cols" style="width: auto">
            <!-- Actions -->
            <div class="gz-col-inner gz-col-inner_actions">
                <button 
                    title="Заблокировать"
                    class="gz-icon_cercle gz-icon_cercle_default">
                    <span class="icon-blocked"></span>
                </button>
            </div>
        </GZ-TableDataCol>
    </section>
</template>

<script>
export default {
    name: 'BaseStaffRow',

    props: {    
        data: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>